export const translations = {
	'Account context has been changed in order to edit': {
		no: 'Konto kontekst er endret for og kunne redigere',
	},
	'Window': {
		no: 'Vindu',
	},
	'Select agent...': {
		no: 'Velg agent... ',
	},
	'Modelerror': {
		no: 'Modellfeil',
	},
	'Note': {
		no: 'Notat',
	},
	'Servicelog': {
		no: 'Tjenestelogg',
	},
	'SLA': {
		no: 'SLA',
	},
	'System message': {
		no: 'Systemmelding',
	},
	'Acknowledged date': {
		no: 'Bekreftet dato',
	},
	'Size': {
		no: 'Størrelse',
	},
	'Please select services...': {
		no: 'Velg tjenester...',
	},
	'In maintenance': {
		no: 'Vedlikehold',
	},
	'Select 1:m asset/targets below to include them in the servicequalifier configuration. Note that each selected asset creates identical servicequalifier.':
		{
			no: 'Velg 1:m ressurser/ressursmål fra listen nedenfor for å inkludere dem i tjenestepunktkonfigurasjonen. For hvert valgte ressursmål opprettes et identisk tjenestepunkt.',
		},
	'Service designer': {
		no: 'Tjeneste designer',
	},
	"Root node can't be a target": {
		no: 'Rotnoden kan ikke være mål',
	},
	'Service element can only have 1 input': {
		no: 'Element kan bare ha 1 inngang',
	},
	"Service link can't have subnodes": {
		no: 'Tjenestekoblingen kan ikke ha subnoder',
	},
	'A service element do not have path to the root': {
		no: 'Element har ingen vei til roten',
	},
	'This will remove aggregation and state rule': {
		no: 'Dette vil fjerne aggregeringen og reglesettet vil bli nullstilt',
	},
	'Change account in order to create a servicequalifier': {
		no: 'Du må endre konto for å opprette tjenestepunkt',
	},
	'Servicequalifier share': {
		no: 'Tjenestepunkt del',
	},
	'Servicequalifier is shared': {
		no: 'Tjenestepunkt er delt',
	},
	'Servicequalifier convert': {
		no: 'Tjenestepunkt konverter',
	},
	'Shared servicequalifiers': {
		no: 'Delte tjenestepunkt',
	},
	'Shared servicequalifier': {
		no: 'Delt tjenestepunkt',
	},
	'Are you sure you want to change the state to aggregated for this element? All servicequalifiers will be removed and state rule will be cleared from this element.':
		{
			no: 'Vil du endre tilstand til aggregert element? Alle tjenestepunkter og regler for tjenesteelementet vil bli slettet.',
		},
	'Are you sure you want to change the state to non-aggregated? The state rule will be cleared': {
		no: 'Vil du endre tilstand til ikke-aggregert element. Alle regler vil bli slettet.',
	},
	'Blank element': {
		no: 'Tomt element',
	},
	'Create template': {
		no: 'Opprett mal',
	},
	'Paste element': {
		no: 'Lim inn element',
	},
	'Create service element': {
		no: 'Nytt tjenesteelement',
	},
	'Template element': {
		no: 'Malelement',
	},
	'Servicequalifier is modified and must be saved before creating a template. Click OK to save servicequalifer (and all other changes done in servicemodel) to continue. Click cancel to return not designer and not create the template.':
		{
			no: 'Tjenestepunktet er modifisert og må lagres før tjenestemal kan opprettes. Klikk OK for å lagre tjenestepunktet (og alle andre endringer som utført på tjenestemodellen) for å fortsette. Klikk på Avbryt for å returnere ikke designer og ikke opprett mal.',
		},
	'Servicequalifier is converted': {
		no: 'Tjenestepunktet konvertert',
	},
	'There are errors in servicemodel. Fix before saving': {
		no: 'Det er feil i modellen.',
	},
	'Service element {0} contains invalid ruleset': {
		no: 'Et element {0} inneholder ugyldig regelsett',
	},
	'You have unsaved content in designer. You will lose changes if you click Close. Click Cancel and save the changes if you want to keep the changes.':
		{
			no: 'Du har ulagret innhold i designer, du vil miste endringen hvis du klikker Lukk. Trykk avbryt og lagre endringen hvis du vil beholde endringene.',
		},
	'Save servicemodel as template': {
		no: 'Lagre tjenestemodell som mal',
	},
	'Save service element as template': {
		no: 'Lagre tjenesteelement som mal',
	},
	'Input template name': {
		no: 'Sett inn navn på mal',
	},
	'Template saved': {
		no: 'Mal er lagret',
	},
	'Enter a description...': {
		no: 'Skriv inn beskrivelse...',
	},
	'Aggregate state from': {
		no: 'Aggreger tilstand fra',
	},
	'Service elements': {
		no: 'Tjenesteelement',
	},
	'State expression rule': {
		no: 'Tilstandsregel',
	},
	'Ruleset': {
		no: 'Regelsett',
	},
	'Weighted': {
		no: 'Vektet',
	},
	'Show warning: This only applies if aggregate state is from servicequalifiers and ruleset is set. If checked the element\nwill be in warningstate (orange) if 1:m servicequalifier is breached, but due to ruleset does not trigger a breached state in the \nserviceelement. ':
		{
			no: 'Vis advarsel: Dette gjelder bare hvis aggreger tilstand er fra tjenestepunkt og regelsett er angitt. Hvis satt vil elementet\nbli satt til advarsel (oransje) om 1:m tjenestepunkt brytes, men på grunn av regelsett ikke medfører et brudd på tjeneste elementet',
		},
	'Show warning': {
		no: 'Vis advarsel',
	},
	'Service is deleted': {
		no: 'Tjeneste er slettet.',
	},
	'- Use Service team -': {
		no: '- Bruk tjeneste team -',
	},
	'New': {
		no: 'Ny',
	},
	'There are no servicequalifiers': {
		no: 'Det er ingen Tjenestepunkt',
	},
	'Service element {0}': {
		no: 'Tjeneste element {0}',
	},
	'Number of service elements with AVAILABLE (green) state, for the parent element to be AVAILABLE': {
		no: 'Minimum antall tjenesteelementer med TILGJENGELIG /grønn) tilstand for at hovedelementet skal være TILGJENGELIG',
	},
	'Number of servicequalifiers with AVAILABLE (green) state, for the element to be AVAILABLE': {
		no: 'Minimum antall tjenestepunkter med TILGJENGELIG (grønn) tilstand for at tjenesteelementet skal være TILGJENGELIG',
	},
	'Required percentage of service elements with AVAILABLE (green) state, for the parent element to be AVAILABLE': {
		no: 'Nødvendig prosentdel tjenesteelementer med TILGJENGELIG /grønn) tilstand for at hovedelementet skal være TILGJENGELIG',
	},
	'Required percentage of servicequalifiers with AVAILABLE (green) state, for the element to be AVAILABLE': {
		no: 'Nødvendig prosentdel tjenestepunkter med TILGJENGELIG (grønn) tilstand for at tjenesteelementet skal være TILGJENGELIG',
	},
	'Counter': {
		no: 'Teller',
	},
	'Servicequalifier template': {
		no: 'Tjenestepunktmal',
	},
	'Closing the window will clear selected assets from the servicequalifier configuration': {
		no: 'Lukkes vinduet vil alle valgte ressurser fjernes fra denne tjenestepunkt konfigurasjonen',
	},
	'All assets': {
		no: 'Alle ressurser',
	},
	'Servicequalifier is shared. Changes will affect all places servicequalifier is referred. Are you sure you want to continue?':
		{
			no: 'Dette tjenestepunktet er delt. Endring vil bli reflektert i alle plasser hvor tjenestepunktet er i bruk. Er du sikker på at du vil fortsette?',
		},
	'Factor': {
		no: 'Faktor ',
	},
	'Operation and grouping': {
		no: 'Gruppering',
	},
	'Service element rule': {
		no: 'Tjenesteelement regel',
	},
	'Verify that rule is correct as a servicequalifier has been removed from it': {
		no: 'Sjekk at regel er korrekt. Et tjenestepunkt er fjernet fra den',
	},
	'Invalid rule. Wrong parameter order': {
		no: 'Ugyldig regel. Feil rekkefølge på parameterene',
	},
	'Invalid rule. Uneven closing brackets': {
		no: 'Ugyldig regel. Paranteser er ikke riktig satt',
	},
	'Select authentication...': {
		no: 'Velg autentisering...',
	},
	'Please add target to your asset.': {
		no: 'Legg til mål for din ressurs',
	},
	'Edit asset': {
		no: 'Rediger ressurs',
	},
	'New servicemodel': {
		no: 'Ny tjenestemodell',
	},
	'Servicemodel link': {
		no: 'Tjenestemodell link',
	},
	'Servicemodel': {
		no: 'Tjenestemodell',
	},
	'No Revisions created in service. A revision is created when you update servicemodel.': {
		no: 'Det er ingen revisjoner for denne tjenesten. En revisjon blir opprett om du oppdaterer tjenestemodellen',
	},
	'When service is shared it is available as link object in a subaccount servicemodel.': {
		no: 'Når tjenesten er delt kan den velges som linkobjekt i en underkonto sin tjenestemodell',
	},
	'No documents are created in service. Click here or in menu to add a document.': {
		no: 'Det er ikke noe dokument i denne tjenesten. Klikk her eller i menyen for å legge til et dokument.',
	},
	'Icon': {
		no: 'Ikon',
	},
	'You do not have permission to create a new service model': {
		no: 'Du har ikke rettigheter til å opprette en tjenestemodell.',
	},
	'Update the service first.': {
		no: 'Du må lagre tjenesten først.',
	},
	'You do not have permission to update a service model': {
		no: 'Du har ikke rettigheter til å oppdatere en tjenestemodell.',
	},
	'Are you sure you want to delete the attached servicemodel?': {
		no: 'Vil du slette tjenestemodellen?',
	},
	'This will also delete the related SLAs.': {
		no: 'Tilhørende SLA vil bli slettet',
	},
	'Servicemodel successfully deleted.': {
		no: 'Tjenestemodell er slettet.',
	},
	'Create servicemodel to see service history': {
		no: 'Opprett tjenestemodell for å se tjenestehistorikk.',
	},
	'Total SLA in BREACHED state:': {
		no: 'Totalt antall SLA i brudd tilstand:',
	},
	'Total SLA in WARNING state:': {
		no: 'Totalt antall SLA i advarsel tilstand:',
	},
	'Total SLA in COMPLIANT state:': {
		no: 'Totalt antall SLA i samsvar tilstand:',
	},
	'Total linked services in BREACHED state:': {
		no: 'Tilkoblede tjenester i bruddtilstand',
	},
	'Total linked services in WARNING state:': {
		no: 'Tilkoblede tjenester i advarseltilstand',
	},
	'Total linked services in OK state:': {
		no: 'Tilkoblede tjenester i OK tilstand',
	},
	'Asset without healthindex:': {
		no: 'Ressurser uten helseindeks:',
	},
	'Total asset in CRITICAL state:': {
		no: 'Totalt antall ressurser i kritisk tilstand:',
	},
	'Total asset in MAJOR state:': {
		no: 'Totalt antall ressurser i alvorlig tilstand:',
	},
	'Total asset in MINOR state:': {
		no: 'Totalt antall ressurser i varsel tilstand:',
	},
	'Total asset in OK state:': {
		no: 'Totalt antall ressurer i OK tilstand:',
	},
	'Asset groups without healthindex:': {
		no: 'Ressursgrupper uten helseindeks',
	},
	'Total asset groups in CRITICAL state:': {
		no: 'Antall ressursgrupper i KRITISK tilstand:',
	},
	'Total asset groups in MAJOR state:': {
		no: 'Antall ressursgrupper i ALVORLIG tilstand:',
	},
	'Total asset groups in MINOR state:': {
		no: 'Antall ressursgrupper i VARSEL tilstand:',
	},
	'Total asset groups in OK state:': {
		no: 'Antall ressursgrupper i OK tilstand:',
	},
	'Total incidents in HIGH state:': {
		no: 'Totalt antall saker i HØY tilstand:',
	},
	'Total incidents in MEDIUM state:': {
		no: 'Totalt antall saker i MEDIUM tilstand:',
	},
	'Total incidents in LOW state:': {
		no: 'Totalt antall saker i LAV tilstand:',
	},
	'Service warning': {
		no: 'Tjenesteadvarsel',
	},
	'Service time': {
		no: 'Tjeneste tid',
	},
	'Current time': {
		no: 'Gjeldende tid',
	},
	'Create document': {
		no: 'Opprett dokument',
	},
	'Edit document': {
		no: 'Rediger dokument',
	},
	'Are you sure you want to delete attached document?': {
		no: 'Vil du slette dokumentet',
	},
	'Document successfully deleted': {
		no: 'Dokument er slettet',
	},
	'Document set to display in configuration': {
		no: 'Dokument vises i tjeneste detalj',
	},
	'Document removed from display in configuration': {
		no: 'Dokumentene ble skjult i tjeneste detalj',
	},
	'Document is temporary saved': {
		no: 'Dokumentet er lagret',
	},
	'Document successfully created': {
		no: 'Dokument er opprettet',
	},
	'Document successfully updated': {
		no: 'Dokument er oppdatert',
	},
	'Please, upload a file.': {
		no: 'Last opp fil',
	},
	'Create new service': {
		no: 'Lag en ny tjeneste',
	},
	'Delete service': {
		no: 'Slett tjeneste',
	},
	'Are you sure you want to remove service?': {
		no: 'Er du sikker på at du vil slette denne tjenesten?',
	},
	'Service successfully deleted': {
		no: 'Tjenesten er slettet',
	},
	'Model state': {
		no: 'Modelltilstand',
	},
	'No services are created for account. Click here or in menu to create service.': {
		no: 'Ingen tjenester er opprettet for denne kontoen. Klikk her eller i menyen for å opprette en tjeneste.',
	},
	'Mode': {
		no: 'Modus',
	},
	'Are you sure you want to remove services?': {
		no: 'Vil du slette disse tjenestene?',
	},
	'Please select service': {
		no: 'Velg en tjeneste',
	},
	'Select time you want to recalculate service from. This will change service and service element state if servicequalifiers has been added or deleted.':
		{
			no: 'Velg tiden du vil rekalkulere tjenesten fra. Dette vil endre tjeneste og element tilstand hvis det er lagt til eller slettet tjenestepunkt.',
		},
	'Recalculating service {0} of {1}. Be patient this might take some time.': {
		no: 'Rekalkulerer tjeneste {0} av {1}. Det kan ta litt tid.',
	},
	'Recalculating services {0} of {1}. Be patient this might take some time.': {
		no: 'Rekalkulerer tjeneste {0} av {1}. Det kan ta litt tid.',
	},
	'{0} of {1} services have been recalculated.': {
		no: '{0} av {1} tjenester ble rekalkulert',
	},
	'Add log entry': {
		no: 'Legg til loggmelding',
	},
	'Acknowledge all': {
		no: 'Bekreft alle',
	},
	'No servicelog entries for the given interval.': {
		no: 'Det er ingen tjenestelogg helseårsaker for gitt intervall.',
	},
	'State qualifier': {
		no: 'Tjenestepunkt tilstand',
	},
	'State model': {
		no: 'Modell tilstand',
	},
	'State element': {
		no: 'Element tilstand',
	},
	'Service incident': {
		no: 'Tjenestesak',
	},
	'Servicequalifier state': {
		no: 'Tjenestepunkt tilstand',
	},
	'Cause': {
		no: 'Årsak',
	},
	'Enter the log entry message here...': {
		no: 'Skriv inn loggmeldingen her...',
	},
	'Enter message': {
		no: 'Sett inn melding',
	},
	'Create Service': {
		no: 'Lag tjeneste',
	},
	'Input service name': {
		no: 'Sett inn navn på tjeneste',
	},
	'Please select a team': {
		no: 'Velg et team',
	},
	'No State Overrides created in service. Click here or in menu to create a state override.': {
		no: 'Det er ingen tilstandsoverstyringer for denne tjenesten. Klikk her eller i menyen for å lage en tilstandsoverstyring.',
	},
	'There are no root cause for the time period.': {
		no: 'Det er ingen helseårsaksanalyser for tidsperioden.',
	},
	'Time from': {
		no: 'Tid fra',
	},
	'Time to': {
		no: 'Tid til',
	},
	'Duration': {
		no: 'Varighet',
	},
	'Create a new service by selecting a servicemodel and associated SLA': {
		no: 'Lag en ny tjeneste ved å velge en tjenestemodell og tilknyttete tjenesteavtale',
	},
	'Complete form to update service setting': {
		no: 'Fyll inn følgende skjema for å oppdatere tjeneste innstillinger',
	},
	'Service successfully created': {
		no: 'Tjenesten er opprettet',
	},
	'Service successfully updated': {
		no: 'tjenesten er oppdatert',
	},
	'Model locked': {
		no: 'Modellen er låst',
	},
	'Open service in <strong>Service Viewer</strong>.': {
		no: 'Åpne denne tjenesten i tjenestevisning',
	},
	'Open service in <strong>Service Details</strong>.': {
		no: 'Åpne denne tjenesten i tjeneste detaljer',
	},
	'Show servicequalifier information for {0}': {
		no: 'Vis tjenestepunkt informasjon for {0}',
	},
	'Show metric graph for {0}': {
		no: 'Vis metrikk graf for {0}',
	},
	'Show metric data for {0}': {
		no: 'Vis metrikk data for {0}',
	},
	'Service element has no qualifiers': {
		no: 'Tjenesteelement har ikke tjenestepunkt',
	},
	'Servicehistory': {
		no: 'Tjenestehistorikk',
	},
	'State expression ruleset': {
		no: 'Tilstand regelsett',
	},
	'Metric data': {
		no: 'Metrikk data',
	},
	'Show ruleset for {0}': {
		no: 'Vis regelsett for {0}',
	},
	'Show service history for {0}': {
		no: 'Vis tjenestehistorikk for {0}',
	},
	'N/A - Service link': {
		no: 'N/A - Tjenestelink',
	},
	'Rule': {
		no: 'Regel',
	},
	'Outside current SLA calculation period.': {
		no: 'Utenfor SLA nåværende kalkuleringsperiode.',
	},
	'Outside current service calculation period.': {
		no: 'Utenfor tjenestens nåværende kalkuleringsperiode.',
	},
	'Last change duration': {
		no: 'Siste endring varighet',
	},
	'Last change time': {
		no: 'Sist endring tidspunkt',
	},
	'Show downtime counter': {
		no: 'Vis nedetidteller',
	},
	'Show breach counter': {
		no: 'Vis bruddteller',
	},
	'Show last change and duration time': {
		no: 'Vis sist endring og varighetstid',
	},
	'Incident counter': {
		no: 'Saksteller',
	},
	'open incidents': {
		no: 'åpne saker',
	},
	'closed incidents': {
		no: 'vsluttede saker',
	},
	'Click counter to see corresponding incidents': {
		no: 'Klikk teller for å åpne gjeldende saker',
	},
	'All services will be displayed': {
		no: 'Alle tjenester blir vist',
	},
	'Elements down or in warning': {
		no: 'Kun nede eller i advarsel',
	},
	'Breached or in warning': {
		no: 'Kun nede eller i advarsel',
	},
	'View': {
		no: 'Vis',
	},
	'We are recalculating the service. Based on the amount of data we have to process this might take some time.': {
		no: 'Vi beregner tjeneste på nytt. Basert på datamengden vi må behandle kan dette ta litt tid.',
	},
	'Select a valid timeperiod': {
		no: 'Velg en gyldig tidsperiode',
	},
	'ExternalId': {
		no: 'Ekstern id',
	},
	'SE presentation': {
		no: 'SE presentasjon',
	},
};
